// Fatia S5b: busca de contas (nome da conta ou e-mail de membro).
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Search } from 'lucide-react'
import { Empty, ErrorState, Loading, PageHead } from '../../ui'
import { AdminNav } from '../../features/admin/AdminNav'
import { useAdminAccounts } from '../../features/admin/api'
import { accountStatusLabel } from '../../features/admin/labels'

const STATUS_CLS: Record<string, string> = { active: 'green', trial: 'purple', past_due: 'amber', readonly: 'amber', suspended: 'red', canceled: '' }

export default function AdminAccounts() {
  const [text, setText] = useState('')
  const [q, setQ] = useState('')
  useEffect(() => { const t = setTimeout(() => setQ(text.trim()), 300); return () => clearTimeout(t) }, [text])
  const r = useAdminAccounts(q)
  const navigate = useNavigate()
  return (
    <>
      <PageHead title="Contas" sub="Busque pelo nome da conta, pelo e-mail de alguém da equipe ou pelo id." />
      <AdminNav />
      <label className="row" style={{ gap: 8, marginBottom: 16, maxWidth: 480 }}>
        <Search size={16} className="muted" />
        <input className="input" autoFocus placeholder="Ex.: Doce Ateliê ou ana@exemplo.com" aria-label="Buscar contas" value={text} onChange={(e) => setText(e.target.value)} />
      </label>
      {r.isLoading && <div className="card"><Loading lines={5} /></div>}
      {r.error && <ErrorState error={r.error} onRetry={() => r.refetch()} />}
      {r.data && r.data.items.length === 0 && <Empty title="Nenhuma conta encontrada">Confira o nome ou o e-mail.</Empty>}
      {r.data && r.data.items.length > 0 && (
        <div className="card flush">
          <div className="table-wrap">
            <table className="table stack-sm">
              <thead><tr><th>Conta</th><th>Tipo</th><th>Situação</th><th>Plano</th><th className="right">Empresas</th><th>Dono</th><th>Criada em</th></tr></thead>
              <tbody>
                {r.data.items.map((a) => (
                  <tr key={a.id} className="clickable" tabIndex={0} onClick={() => navigate(`/admin/contas/${a.id}`)} onKeyDown={(e) => e.key === 'Enter' && navigate(`/admin/contas/${a.id}`)}>
                    <td className="strong">{a.name}</td>
                    <td data-label="Tipo">{a.kind === 'agency' ? 'Agência' : 'Negócio'}</td>
                    <td data-label="Situação"><span className={`badge ${STATUS_CLS[a.status] ?? ''}`}>{accountStatusLabel(a.status)}</span></td>
                    <td className="small" data-label="Plano">{a.planId ?? '—'}</td>
                    <td className="right" data-label="Empresas">{a.companies}</td>
                    <td className="small" data-label="Dono">{a.ownerEmail ?? '—'}</td>
                    <td className="small" data-label="Criada em">{new Date(a.createdAt).toLocaleDateString('pt-BR')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  )
}
